<!--
 * @Author: mzw
 * @Date: 2021-09-17 09:29:32
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-03-31 15:08:58
 * @Description: 下单-订单确认
-->
<template>
  <div class="home_page">
    <el-breadcrumb separator="/" style="line-height: 40px">
      <el-breadcrumb-item :to="{ name: 'basicInfo' }"
        >个人中心</el-breadcrumb-item
      >
      <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="create_order">
      <div class="order_body">
        <el-form ref="dataForm"
                 label-width="90px"
                 label-position="right">
            <!-- 客户信息 -->
            <el-row class="basic-panel basic-panel-customer">
                <h1 class="panel-title">客户信息：</h1>
                <el-col :span="12">
                <el-form-item label="客户公司：" v-if="$store.state.user.defaultCompanyId">{{dataJson.companyName}}</el-form-item>
                </el-col>
                <el-col :span="12">
                <el-form-item label="下单用户：">{{$store.state.user.name}}</el-form-item>
                </el-col>
                <el-col :span="12">
                <el-form-item label="订单号：">
                    <el-input placeholder="请填写贵公司标准采购订单号" v-model="dataForm.custOrderNo" :maxlength="100" style="width:228px;"></el-input>
                </el-form-item>
                </el-col>
            </el-row>
            <!-- 收货地址 -->
            <el-row class="basic-panel">
                <h1 class="panel-title">收货地址：<div class="addBtn-box" @click="()=>addAddress(1)"><img src="@/assets/img/order/addBtn.png"/>新增收货地址</div></h1>
                <AddressBox :addressList='addressList' :showAddressVisible='showAddressVisible' :checkedAddressId='params.addressId'
                            @addressChangeHandle = 'addressChangeHandle'
                            @addressEditHandle = '(row)=>addressEditHandle({...row, type: 1})'
                            @addressDeleteHandle = 'addressDeleteHandle'
                            @toggleAddress = 'toggleAddress' />
            </el-row>
            <!-- 发票信息 -->
            <el-row class="basic-panel basic-panel-bill">
                <h1 class="panel-title">发票信息：<div class="addBtn-box" @click="invoiceAddHandle"><img src="@/assets/img/order/addBtn.png"/>新增发票</div></h1>
                <BillTabs :payInvoiceInfoList='payInvoiceInfoList' :moreInvoiceVisible='moreInvoiceVisible' :checkedInvoiceId='dataForm.invoiceId'
                        @billChangeHandle = 'billChangeHandle'
                        @invoiceEditHandle = 'invoiceEditHandle'
                        @invoiceDeleteHandle = 'invoiceDeleteHandle'
                        @toggleInvoice = 'toggleInvoice'/>
            </el-row>
            <!-- 发票地址 -->
            <el-row class="basic-panel" v-if="invoiceActive !== 'third'">
                <h1 class="panel-title">发票地址：
                    <el-checkbox v-model="asAddress" style="color:#797979;margin-left:10px;" @change="handleAsAddress">同收货地址</el-checkbox>
                    <div class="addBtn-box" @click="()=>addAddress(2)"><img src="@/assets/img/order/addBtn.png"/>新增收票地址</div></h1>
                <AddressBox :showAddressVisible='showAddressVisible_bill'
                            :addressList='!asAddress ? addressList_bill : asAddressList'
                            :checkedAddressId='!asAddress ? params.addressId_bill : asAddressId'
                            :isAsOther='asAddress'
                            @addressChangeHandle = 'addressChangeHandle($event,true)'
                            @addressEditHandle = '(row)=>addressEditHandle({...row, type: 2})'
                            @addressDeleteHandle = 'addressDeleteHandle'
                            @toggleAddress = 'toggleAddress($event,true)' />
            </el-row>
            <el-row class="basic-panel basic-panel-bill">
              <h1 class="panel-title"><span class="red">*</span>发货倾向：</h1>
              <div>
                <div 
                  class="radio-box" 
                  :class="{ 'radio-box-active': deliveryTendency === '1'}" @click="deliveryTendency = '1'"
                >整单发货</div>
                <div
                  class="radio-box" 
                  :class="{ 'radio-box-active': deliveryTendency === '2'}"  @click="deliveryTendency = '2'"
                 >先到先发</div>
              </div>
            </el-row>
            <el-row class="basic-panel basic-panel-bill">
              <h1 class="panel-title">支付方式：</h1>
              <PayInfo :customerPaymentMethod="dataForm.customerPaymentMethod" @changeType="(t) => dataForm.customerPaymentMethod = t" />
            </el-row>
            <!-- 付款类型 -->
            <el-row class="basic-panel" v-if="dataJson.userSign">
                <h1 class="panel-title">付款类型：</h1>
                <el-radio-group class="pay-box" v-model="dataForm.payType">
                    <el-radio :label="'10'">全款发货</el-radio>
                    <el-radio :label="'20'">其他方式</el-radio>
                </el-radio-group>
            </el-row>
            <!-- 商品信息 -->
            <el-row class="basic-panel basic-panel-product">
                <h1 class="panel-title">商品信息：
                    <!-- <div class="addBtn-box" @click="goCart()">返回购物车修改</div> -->
                </h1>
                <productBox :productList='dataJson.payOrderItemRefactoryVos'
                            :isPage='true' :goodsPage='goodsPage' :pageNum='2'
                            @changeGoodsPage='changeGoodsPage' :isSelection="!!lectotypeInquiryNo"
                            @goodDetail='goodDetail' @numberChange="numberChange"  />
            </el-row>
            <!-- 提交订单 -->
            <el-row class="basic-panel">
                <el-col :span="24">
                    <orderPrice :priceData="priceData"
                        :version="'tax'"
                        :hasRemark="true" :orderRemarks="dataForm.orderRemarks"
                        @remarksChange="remarksChange" />
                </el-col>
                <el-col :span="24">
                    <div class="order-submit">
                    <button :loading="buttonLoading" @click.prevent="submit">提交订单</button>
                    <div class="change-box">
                        <!-- <el-checkbox style="color:#333;">要求改价</el-checkbox> -->
                        <p>应付金额：<big>¥{{priceData.totalPay || 0}}</big></p>
                    </div>
                    </div>
                </el-col>
            </el-row>
        </el-form>
      </div>
    </div>
    <!-- 新增/编辑收货地址 弹窗 -->
    <editAddressDialog
      :editAddressVisible="editAddressVisible"
      :editAddressInfo="editAddressInfo"
      :buttonLoading="buttonLoading"
      @handleClose2="handleClose2"
      @handleAddressSaved="handleAddressSaved"
    />
    <!-- 新增/编辑发票 弹窗 -->
    <editBillDialog
      :invoiceVisible="invoiceVisible"
      :invoiceForm="invoiceForm"
      :buttonLoading="buttonLoading"
      @closeInviceHandle="closeInviceHandle"
      @invoiceSaveHandle="invoiceSaveHandle"
    />

    <!-- 删除提示 -->
    <el-dialog
      title=""
      :visible.sync="addressDeleteVisible"
      width="30%"
      :before-close="
        () => {
          addressDeleteVisible = false;
        }
      "
    >
      <span>地址删除后将无法恢复，是否确认？</span>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="addressDeleteVisible = false"
          :loading="buttonLoading"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="confirmAddDelete"
          :loading="buttonLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <company-add
      ref="companyAdd"
      v-if="addCompanyVisible"
      :jumpRoute="false"
    ></company-add>
  </div>
</template>
<script>
// getDictDataList
import { openOther } from '@/utils'
// import region from '@/utils/province-city-county'
import debounce from 'lodash/debounce'
// import { isEmail } from '@/utils/validate'
// import validate from '@/utils/validate'
// import qs from 'qs'
// import Cookies from 'js-cookie'
import CompanyAdd from '@/views/modules/personalCenter/organization/company-add'
import AddressBox from './components/addressList'
import BillTabs from './components/billTabs'
import editAddressDialog from './components/editAddressDialog'
import editBillDialog from './components/editBillDialog'
import productBox from './components/productBox'
import orderPrice from './components/orderPrice'
import PayInfo from './components/payInfo'
export default {
  data () {
    return {
      buttonLoading: false, // 加载中
      // 生成订单参数
      params: {
        orderSource: '',
        // shoppingCart: {},
        // shoppingCartFormList: [],
        payOrderItemRefactoryForms: [],
        // companyId: '',
        // companyName: '',
        addressId: '', // 选中的地址id
        addressId_bill: '' // 选中的发票地址id
        // userId: ''
      },
      // 生成订单返回参数
      dataJson: {
        promotion: 1,
        payOrderItemRefactoryVos: [],
        payMoney: 0,
        expressFee: 0, // 运费
        discountAmount: 0
      },
      // 表单提交参数
      dataForm: {
        // revisionPrice: false, // 是否改价
        // leaveMsg: '', // 改价留言
        // outStock: '10',
        // orderSource: '', // 订单类型
        // shoppingCart: {}, // 商品列表
        // shoppingCartFormList: [], // 商品列表
        invoiceId: '', // 发票Id
        // addressId: '', // 公司地址id
        contractType: '20', // 合同类型(10 自定义合同,20 默认合同,30 无需合同)
        // contractUrl: '', // 合同url
        orderRemarks: '', // 订单备注
        // fullAmount: true, // 是否全款，false否，true是
        payType: '10', // 付款类型：全款10，其他20
        custOrderNo: '', // 客户系统编码
        payOrderInvoice: null, // 选中的-发票信息
        payOrderAddress: null, // 选中的-地址信息
        payOrderAddressInvoice: null, // 选中的-发票地址信息
        customerPaymentMethod: '1' // 支付方式
      },
      deliveryTendency: '',
      goodsPage: 1,
      // 地址
      // region: [],
      addressList: [], // 收货地址
      addressList_bill: [], // 收票地址
      showAddressVisible: true,
      showAddressVisible_bill: true,
      editAddressVisible: false, // 编辑地址弹框
      editAddressInfo: null,
      addressDeleteVisible: false, // 删除地址弹框
      addressDeleteId: '',
      // 发票
      payInvoiceInfoList: [],
      moreInvoiceVisible: true, // 发票列表是否展开
      invoiceVisible: false,
      // 发票对象
      invoiceForm: {
        flagAdd: false,
        invoiceId: '',
        invoiceObjType: '10', // 开票对象类型 10 个人 20 单位
        invoiceObjId: '10', // 开票对象10 用户id 20 公司id
        invoiceType: '10', // 开票类型10 普通发票 20 增值税发票
        companyName: '', // 开票公司名称(发票抬头)
        taxpayerIdentity: '', // 纳税人识别号
        companyAddress: '', // 公司地址
        companyPhone: '', // 联系电话
        openingBank: '', // 开户行
        bankAccountNo: '', // 开户行账号
        // defaultFlag: '10', //  缺省标识 10 默认 20 非默认
        defaultFlag: '1', //  默认发票标识 1 默认 0 非默认
        remarks: '',
        mailingAddress: '', // 发票邮寄地址
        consignee: '', // 收货人
        contactInformation: '' // 收货人联系方式
      },
      addCompanyVisible: false, // 企业账号 dialog
      asAddress: false, // 收票地址是否同收货地址
      asAddressList: [], // asAddress为true时，收票地址展示的地址
      asAddressId: '', // asAddress为true时，收票地址展示的地址栏选中id
      priceData: {
        // 价格相关数据
        taxAmount: '',
        payMoney: '',
        discountAmount: '',
        expressFee: '',
        totalPay: ''
      },
      invoiceActive: 'third',
      lectotypeInquiryNo: '' // 选型询价单号
    }
  },
  computed: {
    companyId () {
      return this.$store.state.user.defaultCompanyId
    }
  },
  components: {
    CompanyAdd,
    AddressBox,
    BillTabs,
    editAddressDialog,
    editBillDialog,
    productBox,
    orderPrice,
    PayInfo
  },
  async mounted () {
    this.addCompanyVisible = false
    // this.region = region.region
    this.params.orderSource = this.$route.query.orderSource
    this.lectotypeInquiryNo = this.$route.query.lectotypeInquiryNo
    if (this.params.orderSource === '10') {
      // 购物车下单
      // this.params.shoppingCartFormList = this.$route.query.shoppingCartFormList ? JSON.parse(this.$route.query.shoppingCartFormList) : ''
      this.params.payOrderItemRefactoryForms = this.$route.query
        .shoppingCartFormList
        ? JSON.parse(this.$route.query.shoppingCartFormList)
        : ''
    } else if (this.params.orderSource === '20') {
      // 立即下单
      // this.params.shoppingCart = this.$route.query.shoppingCart ? JSON.parse(this.$route.query.shoppingCart) : ''
      this.params.payOrderItemRefactoryForms.push(
        JSON.parse(this.$route.query.shoppingCart)
      )
    }
    await this.getaddressDataList()
    // this.getOrderInfo()
    this.getInvoicList()
  },
  methods: {
    // 获取订单详情
    getOrderInfo (refushType) {
      const obj = JSON.parse(JSON.stringify(this.params))
      // 同收货地址功能
      if (this.asAddress && this.invoiceActive !== 'third') {
        obj.addressId_bill = this.params.addressId
      }
      let url = '/front/consumer/shopping/order/generateOrder'
      if(this.$store.state.user.corpUserInfo.customerId){
        url= '/front/consumer/shopping/order/generateOrderWebSite'
      }
      this.$http
        .post(url, {
          ...obj,
          lectotypeInquiryNo: this.lectotypeInquiryNo || undefined,
          platformSource: 2
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          let data = res.data

          // refushType接受参数为rePrice时，表示只刷新价格相关数据
          if (!refushType || refushType !== 'rePrice') {
            this.dataJson = data
          }
          this.priceData = {
            taxAmount: data.taxAmount,
            payMoney: data.payMoney,
            discountAmount: data.discountAmount,
            expressFee: data.expressFee,
            totalPay: data.totalPay
          }
        })
    },
    changeGoodsPage (page) {
      this.goodsPage = page
    },
    // 更改选中的地址
    addressChangeHandle (item, isBill = false) {
      if (!isBill) {
        // 收货地址
        this.params.addressId = item.userAddressId
        this.dataForm.payOrderAddress = item
        if (this.asAddress) {
          this.handleAsAddress()
        }
      } else {
        // 收票地址
        this.params.addressId_bill = item.userAddressId
        this.dataForm.payOrderAddressInvoice = item
      }
      // 切换地址造成运费及相关价格改变（传参rePrice）
      if (!this.asAddress) {
        this.getOrderInfo('rePrice')
      }
    },
    // 关闭弹窗  地址
    handleClose2 () {
      this.editAddressVisible = false
      this.editAddressInfo = {
        companyId: '', // 当前地址对应的公司Id
        userAddressId: '',
        proCityArea: [],
        address: '', // 地址
        orderAddress: '', // 省市区详细地址拼接
        province: '',
        city: '',
        area: '',
        receiveGoodsPerson: '', // 收货人
        receiveGoodsPhone: '', // 收货联系电话
        defaultAddress: false, // 是否默认地址
        used: true // 是否可用
      }
    },
    // 添加地址
    addAddress (type) {
      this.editAddressInfo = {
        type,
        // companyId: this.params.companyId, // 当前地址对应的公司Id
        companyId: this.companyId, // 当前地址对应的公司Id
        userAddressId: '',
        proCityArea: [],
        address: '', // 地址
        orderAddress: '', // 省市区详细地址拼接
        province: '',
        city: '',
        area: '',
        receiveGoodsPerson: '', // 收货人
        receiveGoodsPhone: '', // 收货联系电话
        defaultAddress: false, // 是否默认地址
        used: true // 是否可用
      }
      this.editAddressVisible = true
    },
    // 编辑地址
    addressEditHandle (row) {
      this.editAddressInfo = {
        type: row.type,
        companyId: row.companyId, // 当前地址对应的公司Id
        userAddressId: row.userAddressId,
        proCityArea: [],
        address: row.address, // 地址
        orderAddress: '', // 省市区详细地址拼接
        province: '',
        city: '',
        area: '',
        receiveGoodsPerson: row.receiveGoodsPerson, // 收货人
        receiveGoodsPhone: row.receiveGoodsPhone, // 收货联系电话
        defaultAddress: row.defaultAddress, // 是否默认地址
        used: row.used // 是否可用
      }
      if (row.province) {
        this.editAddressInfo.proCityArea.push(row.province)
        if (row.city) {
          this.editAddressInfo.proCityArea.push(row.city)
          if (row.area) {
            this.editAddressInfo.proCityArea.push(row.area)
          }
        }
      }
      this.editAddressVisible = true
    },
    // 保存地址-新增/修改
    handleAddressSaved: debounce(
      function () {
        this.editAddressInfo.province = this.editAddressInfo.proCityArea[0]
        this.editAddressInfo.city = this.editAddressInfo.proCityArea[1]
        this.editAddressInfo.area = this.editAddressInfo.proCityArea[2]
        this.editAddressInfo.orderAddress =
          this.editAddressInfo.proCityArea.join('') +
          this.editAddressInfo.address
        var _this = this
        this.$http
          .post(
            `/front/consumer/user/address/${
              _this.editAddressInfo.userAddressId
                ? 'updateUserAddress'
                : 'addUserAddress'
            }`,
            this.editAddressInfo
          )
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            }
            _this.$message.success(res.message)
            _this.handleClose2()
            _this.getaddressDataList()
          })
          .catch(() => {})
      },
      1000,
      {
        leading: true,
        trailing: false
      }
    ),
    // 删除地址
    addressDeleteHandle (row) {
      this.addressDeleteId = row.userAddressId
      this.addressDeleteVisible = true
    },
    // 确认删除地址
    confirmAddDelete () {
      if (!this.addressDeleteId) {
        this.addressDeleteVisible = false
        return false
      }
      this.$http
        .post(`/front/consumer/user/address/deleteById/${this.addressDeleteId}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.addressDeleteVisible = false
          this.getaddressDataList()
        })
    },
    // 获取用户地址列表
    async getaddressDataList () {
      let _this = this
      await this.$request
        .get(
          `/front/consumer/user/address/userAddressList?companyId=${
            _this.companyId
          }`
        )
        .then((res) => {
          _this.setAddress(res)
          _this.setBillAddress(res)
        })
        .catch()
    },
    // 设置收货地址 及默认选中项
    setAddress (res) {
      let _this = this
      _this.addressList = res || []
      if (_this.params.addressId) {
        let address = _this.addressList.find((item) => {
          return item.userAddressId === _this.params.addressId
        })
        if (!address) {
          _this.params.addressId = ''
          _this.dataForm.payOrderAddress = null
        } else {
          _this.dataForm.payOrderAddress = address
        }
      }
      if (!_this.params.addressId && _this.addressList.length) {
        let address = _this.addressList.find((item) => {
          return item.defaultAddress === true
        })
        if (address) {
          _this.params.addressId = address.userAddressId
          _this.dataForm.payOrderAddress = address
        } else {
          _this.params.addressId = _this.addressList[0].userAddressId
          _this.dataForm.payOrderAddress = _this.addressList[0]
          // _this.addressChangeHandle(_this.addressList[0].userAddressId);
        }
      }

      this.getOrderInfo()
    },
    // 设置收票地址 及默认选中项
    setBillAddress (res) {
      let _this = this
      _this.addressList_bill = res || []
      if (_this.params.addressId_bill) {
        let address = _this.addressList_bill.find((item) => {
          return item.userAddressId === _this.params.addressId_bill
        })
        if (!address) {
          _this.params.addressId_bill = ''
          _this.dataForm.payOrderAddressInvoice = null
        } else {
          _this.dataForm.payOrderAddressInvoice = address
        }
      }
      if (!_this.params.addressId_bill && _this.addressList_bill.length) {
        let address = _this.addressList_bill.find((item) => {
          return item.defaultAddress === true
        })
        if (address) {
          _this.params.addressId_bill = address.userAddressId
          _this.dataForm.payOrderAddressInvoice = address
        } else {
          _this.params.addressId_bill = _this.addressList_bill[0].userAddressId
          _this.dataForm.payOrderAddressInvoice = _this.addressList_bill[0]
        }
      }
    },
    // 新增发票
    invoiceAddHandle () {
      this.invoiceVisible = true
      // if (this.$refs['invoiceForm']) {
      //     this.$refs['invoiceForm'].resetFields()
      // }
      this.invoiceForm = {
        flagAdd: false,
        invoiceId: '',
        invoiceObjType: '10', // 开票对象类型 10 个人 20 单位
        invoiceObjId: '10', // 开票对象10 用户id 20 公司id
        invoiceType: '10', // 开票类型10 普通发票 20 增值税发票
        companyName: '', // 开票公司名称(发票抬头)
        taxpayerIdentity: '', // 纳税人识别号
        companyAddress: '', // 公司地址
        companyPhone: '', // 联系电话
        openingBank: '', // 开户行
        bankAccountNo: '', // 开户行账号
        // defaultFlag: '10', //  缺省标识 10 默认 20 非默认
        defaultFlag: '1', //  默认发票标识 1 默认 0 非默认
        remarks: '',
        mailingAddress: '', // 发票邮寄地址
        consignee: '', // 收货人
        contactInformation: '' // 收货人联系方式
      }
    },
    // 编辑发票
    invoiceEditHandle (row) {
      this.invoiceVisible = true
      // if (this.$refs['invoiceForm']) {
      //     this.$refs['invoiceForm'].resetFields()
      // }
      this.invoiceForm = {
        // flagAdd: row.defaultFlag === '10',
        flagAdd: row.defaultFlag === '1',
        invoiceId: row.invoiceId,
        invoiceObjType: row.invoiceObjType, // 开票对象类型 10 个人 20 单位
        invoiceObjId: row.invoiceObjId, // 开票对象10 用户id 20 公司id
        invoiceType: row.invoiceType, // 开票类型10 普通发票 20 增值税发票
        companyName: row.companyName, // 开票公司名称(发票抬头)
        taxpayerIdentity: row.taxpayerIdentity, // 纳税人识别号
        companyAddress: row.companyAddress, // 公司地址
        companyPhone: row.companyPhone, // 联系电话
        openingBank: row.openingBank, // 开户行
        bankAccountNo: row.bankAccountNo, // 开户行账号
        defaultFlag: row.defaultFlag, //  默认发票标识
        remarks: row.remarks,
        mailingAddress: row.mailingAddress, // 发票邮寄地址
        consignee: row.consignee, // 收货人
        contactInformation: row.contactInformation // 收货人联系方式
      }
    },
    // 删除发票
    invoiceDeleteHandle (row) {
      this.$confirm('此操作将永久删除该发票?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.$http
            .post(`/front/consumer/order/payinvoice/delete`, [row.invoiceId])
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return false
              }
              this.getInvoicList()
            })
        })
        .catch(() => {})
    },
    // 关闭发票
    closeInviceHandle () {
      this.invoiceVisible = false
      // this.$refs['invoiceForm'].resetFields()
    },
    // 保存发票
    invoiceSaveHandle: debounce(
      function () {
        if (this.invoiceForm.invoiceObjType === '10') {
          this.invoiceForm.invoiceObjId = ''
        } else {
          this.invoiceForm.invoiceObjId = this.companyId
        }
        this.invoiceForm.companyId = this.companyId
        //   this.invoiceForm.defaultFlag = this.invoiceForm.flagAdd ? '10' : '20'
        this.invoiceForm.defaultFlag = this.invoiceForm.flagAdd ? '1' : '0'
        var _this = this
        console.log(this.invoiceForm)
        this.$http
          .post(
            `/front/consumer/order/payinvoice/${
              _this.invoiceForm.invoiceId ? 'update' : 'save'
            }`,
            _this.invoiceForm
          )
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            }
            _this.$message.success(res.message)
            _this.closeInviceHandle()
            _this.getInvoicList()
          })
          .catch(() => {})
      },
      1000,
      {
        leading: true,
        trailing: false
      }
    ),
    // 获取发票列表
    getInvoicList () {
      var _this = this
      this.$request
        .get(
          `/front/consumer/order/payinvoice/getUserAllInvoiceList?companyId=${
            _this.companyId
          }`
        )
        .then((res) => {
          _this.payInvoiceInfoList = res || []
          if (_this.dataForm.invoiceId) {
            // 若有选中的项
            let invoiceInfo = _this.payInvoiceInfoList.find((item) => {
              return item.invoiceId === _this.dataForm.invoiceId
            })
            if (!invoiceInfo) {
              _this.dataForm.invoiceId = ''
              _this.dataForm.payOrderInvoice = null
            } else {
              _this.dataForm.payOrderInvoice = invoiceInfo
            }
          }
          if (!_this.dataForm.invoiceId && _this.payInvoiceInfoList.length) {
            // 若有默认项
            let invoiceInfo = _this.payInvoiceInfoList.find((item) => {
              // return item.defaultFlag === '10'
              return item.defaultFlag === '1'
            })
            if (invoiceInfo) {
              _this.dataForm.invoiceId = invoiceInfo.invoiceId
              _this.dataForm.payOrderInvoice = invoiceInfo
            } else {
              _this.dataForm.invoiceId = ''
              _this.dataForm.payOrderInvoice = null
            }
          }
        })
        .catch()
    },
    // 选型询价修改数量
    numberChange () {
      // NEW_ADD 选型商品对应逻辑
      this.params.payOrderItemRefactoryForms.forEach((item) => {
        const result = this.dataJson.payOrderItemRefactoryVos.find(itm => itm.goodsSkuId === item.goodsSkuId)
        item.goodsNum = result.goodsNum || 0
      })
      // this.params.payOrderItemRefactoryForms = this.params.payOrderItemRefactoryForms.filter(item => item.goodsNum > 0)

      this.getOrderInfo()
    },
    // 提交订单
    submit: debounce(
      function () {
        // if (!this.$store.state.user.defaultCompanyId) {
        //   this.$confirm("个人用户暂不支持下单请先升级为企业客户", "温馨提示", {
        //     dangerouslyUseHTMLString: true,
        //     confirmButtonText: "升级为企业客户",
        //     cancelButtonText: "取消",
        //   }).then(() => {
        //     this.addCompanyVisible = true;
        //     this.$nextTick(() => {
        //       this.$refs.companyAdd.init();
        //     });
        //   });
        //   return false;
        // }
        if (!this.params.addressId) {
          this.$message.warning('请选择收货地址')
          return
        }
        // 如果要开票
        if (this.invoiceActive !== 'third') {
          if (!this.dataForm.invoiceId) {
            this.$message.warning('请选择发票')
            return
          }
          if (!this.params.addressId_bill && !this.asAddress) {
            this.$message.warning('请选择收票地址')
            return
          }
        }
        if(!this.deliveryTendency){
          this.$message.warning('请选择发货倾向')
          return
        }

        // //  企业用户发票必填
        // if (dataJson.companyName && !this.dataForm.invoiceId) {
        //   this.$message.warning('请选择发票信息')
        //   return
        // }
        if (this.buttonLoading) {
          return false
        }
        this.dataForm.payOrderAddress.addressId = this.params.addressId
        this.dataForm.payOrderAddressInvoice.addressId = this.params.addressId_bill
        const obj = {
          ...this.dataForm,
          ...this.params,
          lectotypeInquiryNo: this.lectotypeInquiryNo || undefined, // 选型商品型号
          platformSource: 2
        }
        // 同收货地址功能
        if (this.asAddress && this.invoiceActive !== 'third') {
          obj.addressId_bill = this.params.addressId
          obj.payOrderAddressInvoice = JSON.parse(JSON.stringify(this.dataForm.payOrderAddress))
        }
        // 不开发票
        if (this.invoiceActive === 'third') {
          delete obj.payOrderInvoice
          delete obj.payOrderAddressInvoice
          delete obj.addressId_bill
        }
        // NEW_ADD 选型商品对应逻辑
        obj.payOrderItemRefactoryForms.forEach((item) => {
          const result = this.dataJson.payOrderItemRefactoryVos.find(itm => itm.goodsSkuId === item.goodsSkuId)
          item.goodsNum = result.goodsNum
        })

        obj.payOrderItemRefactoryForms = obj.payOrderItemRefactoryForms.filter(item => item.goodsNum > 0)
        if (obj.payOrderItemRefactoryForms.length === 0) {
          this.$message.warning('请填写至少一个选型商品数量')
          return
        }
        // 用户选完把内容拼接到备注里
        if(this.deliveryTendency === '1'){
          obj.orderRemarks = '发货倾向：整单发货。'+obj.orderRemarks 
        }else if(this.deliveryTendency === '2'){
          obj.orderRemarks = '发货倾向：先到先发。'+obj.orderRemarks 
        }
        this.buttonLoading = true

        let url = '/front/consumer/shopping/order/submitOrder'
        // 企业站
        if(this.$store.state.user.corpUserInfo.customerId){
          url = '/front/consumer/shopping/order/submitOrderWebSite'
        }
        // 询价单
        if(this.lectotypeInquiryNo){
          url = '/front/commodity/manager/lectotypeInquiry/record/submitOrder'
        }
        this.$http
          .post(url,obj)
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            } else {
              this.$store.dispatch(
                'setShoppingCartCount',
                this.$store.state.shoppingCartCount + 1
              )
              // 选型询价商品则跳转立即支付
              if (this.lectotypeInquiryNo) {
                this.$router.push({
                  name: 'orderPay',
                  query: {
                    id: res.data,
                    money: this.priceData.totalPay
                  }
                })
              } if (this.dataForm.customerPaymentMethod === '2') {
                // 如果是转账支付的话，跳转到转账支付页面
                this.$router.push({
                  name: 'enterpriseTransferPayment',
                  query: {
                    id: res.data,
                    money: this.priceData.totalPay
                  }
                })
              } else {
                this.$router.replace({
                  name: 'orderDetail',
                  params: {
                    id: res.data
                  }
                })
              }
            }
          })
          .finally(() => {
            this.buttonLoading = false
          })
      },
      1000,
      {
        leading: true,
        trailing: false
      }
    ),
    billChangeHandle (item) {
      this.dataForm.invoiceId = item.invoiceId
      this.dataForm.payOrderInvoice = item
    },
    // goCart() {
    //     this.$router.push({
    //         name: 'myShopCart'
    //     })
    // },
    toggleAddress (flag, isBill = false) {
      if (!isBill) {
        this.showAddressVisible = !flag
      } else {
        this.showAddressVisible_bill = !flag
      }
    },
    toggleInvoice (activeName) {
      this.invoiceActive = activeName
      if (this.invoiceActive === 'third') {
        this.dataForm.invoiceId = undefined
        this.asAddress = false
        // this.params.addressId_bill = undefined
        this.asAddressId = undefined
      }
      this.moreInvoiceVisible = false
    },
    remarksChange (val) {
      this.dataForm.orderRemarks = val
    },
    // 跳转商品详情
    goodDetail (row) {
      openOther(`goodDetail?spuId=${row.goodsSpuId}&skuId=${row.goodsSkuId}`)
    },
    handleAsAddress () {
      if (this.asAddress) {
        // 同收货地址
        this.asAddressList = this.addressList.filter((item) => {
          return item.userAddressId === this.params.addressId
        })
        this.asAddressId = this.params.addressId
      }
      this.getOrderInfo('rePrice')
    }
  }
}
</script>
<style lang="scss" scoped>
.create_order {
  background: #fff;
  padding: 30px 0;
  .order_body {
    width: 1136px;
    margin: 0 auto;
    .basic-panel {
      margin-bottom: 20px;
      .panel-title {
        font-size: 20px;
        line-height: 28px;
        font-weight: 600;
      }
      .addBtn-box {
        font-size: 14px;
        height: 20px;
        line-height: 20px;
        color: #3d88d4;
        float: right;
        cursor: pointer;
        img {
          width: 16px;
          height: 16px;
          display: block;
          float: left;
          margin: 2px 6px;
        }
      }

      .pay-box {
        .el-radio {
          width: 148px;
          height: 48px;
          line-height: 48px;
          text-align: center;
          border: 1px solid #ddd;
          /deep/.el-radio__input {
            display: none;
          }
          &.is-checked {
            position: relative;
            border-color: #3d88d4;
            &:after {
              content: "";
              display: block;
              height: 47px;
              width: 47px;
              background-image: url("./../../../assets/img/order/checkIcon.png");
              background-size: 100%;
              position: absolute;
              right: -21px;
              bottom: -20px;
            }
          }
          /deep/.el-radio__input.is-checked + .el-radio__label {
            color: #333 !important;
          }
          /deep/.el-radio__input.is-checked .el-radio__inner {
            background: #333 !important;
            border-color: #333 !important;
          }
        }
      }
      .order-submit {
        background-color: #eee;
        overflow: hidden;
        .change-box {
          float: right;
          text-align: right;
          margin: 25px 80px 0 0;
          p {
            line-height: 30px;
            margin: 0;
            big {
              font-size: 16px;
              color: #ff3636;
            }
          }
        }
        button {
          background: #ff3636;
          width: 182px;
          height: 80px;
          line-height: 80px;
          border: none;
          color: #fff;
          cursor: pointer;
          float: right;
        }
      }
    }
    .basic-panel-customer {
      .el-form-item {
        margin-bottom: 10px;
      }
    }
    .basic-panel-bill {
      >>> .el-tabs--card > .el-tabs__header {
        border-bottom: none;
        .el-tabs__nav {
          border: none;
        }
      }
      >>> .el-tabs__item {
        width: 148px;
        line-height: 38px;
        text-align: center;
        font-size: 14px;
        border: 1px solid #ddd;
        margin-right: 16px;
        &.is-active {
          background-color: #e5f0ff;
          color: #333;
          border-color: #3d88d4;
        }
      }
    }
  }
  .radio-box{
    display: inline-block;
    margin-right: 16px;
    width: 100px;
    line-height: 28px;
    font-size: 14px;
    background: #fff;
    border: 1px solid #e4e7ed;
    text-align: center;
    cursor: pointer;
    color: #333;
  }
  .radio-box-active{
    border-color: #3d88d4;
  }
  .red{
    color: #e93037;
  }
}
</style>
